module.exports = __webpack_public_path__ + "static/media/octopusCard.7c850350.png";